import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { IndicadorPostoComponent } from '../indicador-posto/indicador-posto.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { boxInfo } from '../../modal/boxInfo';
import { VagasDisponiveisComponent } from '../vagas-disponiveis/vagas-disponiveis.component';
import { IndicadorService } from '../../service/Indicador.service';
import { delay, firstValueFrom, forkJoin, Observable, of, retry, tap } from 'rxjs';
import { CORES } from '../../modal/mock-cor';
import { ICONE } from '../../modal/icone';
import { farolmodal } from '../../modal/farolmodal';
import { TamanhoTituloService } from '../../cache/tamanho-indicador';
import { ClasseSalaSituacao } from '../../modal/ControlePermissaoUsers_SalaSituacao';
import { AuthService } from '../../service/auth.service';
import { breadcrumb } from '../../modal/breadcrumb';
import { AtualizacaoIndicador } from '../../modal/AtualizacaoIndicador';
import { SharedDataService } from '../../service/SharedDataService ';
import { LoadingIndicadoresService } from '../../loading-indicadores/loading-indicadores.service';
import { UtilSharedDataService } from '../../service/UtilSharedDataService';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltip,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormControl } from '@angular/forms';
import { Console } from 'node:console';

/** Custom options the configure the tooltip's default show/hide delays. */
export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 1000,
  hideDelay: 1000,
  touchendHideDelay: 10000,
};

@Component({
    selector: 'app-indicador-dashboard',
    standalone: true,
    imports: [
        MatSidenavModule,
        MatCardModule,
        MatMenuModule,
        CommonModule,
        RouterLink,
        RouterOutlet,
        RouterModule,
        IndicadorPostoComponent,
        VagasDisponiveisComponent,        
        MatTooltipModule,
        MatIconModule,
      
    ],
    providers: [ICONE,{provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults}],
    templateUrl: './indicador-dashboard.component.html',
    styleUrl: './indicador-dashboard.component.scss'
})
export class IndicadorDashboardComponent implements OnInit, OnDestroy {
    public listaInd: boxInfo[] = [];
    public listaAtualizacaoIndicador: AtualizacaoIndicador[] = [];
    data = [];
    intervalIds: any[] = [];
    cores = CORES;
    maiorTamanhoTitulo: number = 0;
    IndicadorTamanhoIntervalo: number = 0;
    perfil: any;
    listabreadcrumb: breadcrumb[] = [];
    private postosUsuario: number[] | undefined;
    receivedCcPosto!: string;
    receivedDescPosto!: string;
    public CarregandoTodosIndicadores = false;
    isFixed: boolean = false;
    @ViewChild('menu', { static: true }) menu!: ElementRef;
    initialTopPosition: number = 0;
    
     
    constructor(private indicadorService: IndicadorService,
        private icon: ICONE,
        private router: Router, private utilSharedDataService: UtilSharedDataService,
        private tamanhoTituloService: TamanhoTituloService,
        private authService: AuthService,
        private cdr: ChangeDetectorRef,
        private sharedDataService: SharedDataService,
        private loadingService: LoadingIndicadoresService,
        private bpObserver: BreakpointObserver,
        private el: ElementRef) {
        try {
            (async () => {
                await new Promise(f => setTimeout(f, 1000));
                let login = localStorage.getItem('login');
                if (login == null || login == undefined) {
                    this.router.navigate(['/iniciar']);
                }
            })();

        }
        catch (ex) {
            console.log('IndicadorDashboardComponent.constructor catch');
            console.log(ex);
        }
        this.listabreadcrumb = [
            new breadcrumb("Dashboard", "/dashboard")
        ];
        this.bpObserver.observe(['(min-width: 573px) and (max-width: 613px)'])
            .subscribe(result => {
                if (result.matches) {
                    const largura = window.innerWidth;
                    var telaPadrao = 80
                    this.IndicadorTamanhoIntervalo = telaPadrao-(largura /10);
                }
                else
                    this.IndicadorTamanhoIntervalo = 0;
            });
    }

    

    ngAfterViewInit() {
        this.initialTopPosition = this.menu.nativeElement.getBoundingClientRect().top + window.scrollY;
       
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        const currentScrollPosition = window.scrollY;

        if (currentScrollPosition >= this.initialTopPosition) {
            this.isFixed = true;
        } else {
            this.isFixed = false;
        }
    }

    tirarFiltroPosto() {
        this.sharedDataService.updateDescPostoSource("");
        this.sharedDataService.updateCcPosto("");
    }

    ngOnInit() {
        this.utilSharedDataService.updateModoApresentacao(false);

        this.sharedDataService.descPosto$.subscribe(string => {
            localStorage.setItem('receivedDescPosto', string);
            this.receivedDescPosto = string;
        });
        this.sharedDataService.ccPosto$.subscribe(string => {
            if (string != this.receivedCcPosto) {
                this.loadingService.show();
                localStorage.setItem('receivedCcPosto', string);
                this.listaInd = [];
                this.intervalIds.forEach(intervalId => clearInterval(intervalId));
                this.receivedCcPosto = string;
                this.GetIndicadores();

            }
        });
        var _receivedDescPosto = localStorage.getItem('receivedDescPosto');
        if (_receivedDescPosto != null)
            this.receivedDescPosto = _receivedDescPosto;
        var _receivedCcPosto = localStorage.getItem('receivedCcPosto');
        if (_receivedCcPosto != null)
            this.receivedCcPosto = _receivedCcPosto;

        this.CarregandoTodosIndicadores = true;
        (async () => {
            await new Promise(f => setTimeout(f, 500));
            this.GetIndicadores();
        })();
    }

    toggleTooltip(tooltip: MatTooltip,  event: MouseEvent) {
                   
         event.preventDefault();
         event.stopPropagation();

         if (tooltip._isTooltipVisible()) {
            tooltip.hide();
        } else {
            tooltip.show();
  }
       
                   
    }
      
    public async GetIndicadores() {
        let login = localStorage.getItem('login');
        const loginValue = login == undefined ? "" : login;

        this.perfil = await this.authService.roleWithTempAsync();

        let farolComoCorPrincipal = false;
        var retrievedObject = localStorage.getItem('salaSituacao');

        if (retrievedObject != null) {
            var sala = JSON.parse(retrievedObject);

            this.postosUsuario = sala['postos'];
            this.listaInd = [];
            this.listaAtualizacaoIndicador = [];

            this.indicadorService.findIndicadores(this.postosUsuario, loginValue, this.receivedCcPosto).subscribe(async (response) => {
                console.log(response);
                this.data = response["indicadores"];
                console.log("teste ::: ",this.data)
               
                let farolComoCorPrincipal = false;
                

                for (const element of this.data) {
                    let farolComoCorPrincipal = false;
                    // Agrupar tempo de atualização
                    let A = this.listaAtualizacaoIndicador.find(x => x.tempoAtualizacao == element['tempoAtualizacao']);
                    if (!A) {
                        this.listaAtualizacaoIndicador.push(new AtualizacaoIndicador("" + element['codigo'], element['tempoAtualizacao']));
                    } else {
                        A.codigoIndicadores += ", " + element['codigo'];
                    }

                    // === Decide a cor principal e o farol visual ===
                    let corPrincipal, corFarolVisual;

                    if (element['farolCorPrincipal']) {
                        farolComoCorPrincipal = true
                        const farolResp = await firstValueFrom(
                            this.indicadorService.GetFarol(this.postosUsuario, element['codigo'], loginValue, this.receivedCcPosto)
                        );
                        corPrincipal = this.cores.find(c => c.status == farolResp["indicador_cor_farol"]);
                        corFarolVisual = undefined; // oculta o farol visual
                    } else {
                        corPrincipal = this.cores.find(c => c.status == element['cor']);
                        corFarolVisual = this.cores.find(c => c.status == element['corFarol']);
                    }

                    this.listaInd.push(new boxInfo(
                        element['codigo'],
                        element['nome'],
                        element['linkRedirect'],
                        corPrincipal?.status === "Roxo" ? corPrincipal : this.cores.find(c => c.status == element['cor']),
                        element['valor']['valorFormatado'],
                        undefined,
                        element['icone'],
                        corFarolVisual,
                        false,
                        element['cabecalho'],
                        element['descricao'],
                        farolComoCorPrincipal
                    ));

                    
                }

                // Finaliza
                this.maiorTamanhoTitulo = Math.max(...this.listaInd.map(i => i.nome.length));
                var maiorCabecalho = Math.max(...this.listaInd.map(i => i.cabecalho == null? 0 :i.cabecalho.length));
                if(maiorCabecalho> this.maiorTamanhoTitulo)
                {
                    console.log("maiorCabecalho",maiorCabecalho)
                    this.maiorTamanhoTitulo = maiorCabecalho-7;
                }
                this.tamanhoTituloService.setMaiorTamanhoTitulo(this.maiorTamanhoTitulo);
                this.CarregandoTodosIndicadores = false;
                this.loadingService.hide("CarregaInd");

                // Atualizações por tempo
                this.listaAtualizacaoIndicador.forEach(element => {
                    this.setAtualizacaoindicadores(
                        element.tempoAtualizacao,
                        element.codigoIndicadores,
                        element.codigoIndicadores.split(','),
                        loginValue
                    );
                });


                this.data
                    .filter(e => !e['farolComoCorPrincipal'])
                    .forEach(e => this.setFarol(e['codigo'], loginValue));
            });
        }
        
    }




    ngOnDestroy() {
        this.intervalIds.forEach(intervalId => clearInterval(intervalId));
    }



    setFarol(CodigoIndicador: string, login: string): Observable<any> {
        const oldind = this.listaInd.find(x => x.id == CodigoIndicador);
        if (oldind) {
            oldind.atualizando = true;
            //console.log("Inicio Carregamento farol: ", CodigoIndicador, oldind);
        
            this.indicadorService.GetFarol(this.postosUsuario, CodigoIndicador, login, this.receivedCcPosto).subscribe
            (async (response) => {
                    //console.log("FIM Carregamento farol: ", CodigoIndicador, response);
                    if(!oldind.farolCorPrincipal)
                    oldind.corfarol = this.cores.find(x => x.status == response["indicador_cor_farol"]);
                    oldind.atualizando = false;
                    
                });
        }
        else
        {
            console.log(CodigoIndicador);
        }
        return of(null);
    }





    setAtualizacaoindicadores(timeInterval: number, CodigoIndicador: string, CodigosIndicador: string[], login: string) {

        const intervalId = setInterval(() => {
            CodigosIndicador.forEach(element => {
                var i = this.listaInd.find(x => x.id == element.trim())
                if (i != undefined)
                    i.atualizando = true;
            });
            this.indicadorService.AtualizaIndicador(this.postosUsuario, CodigoIndicador, login, this.receivedCcPosto).pipe(
            ).subscribe((response) => {
                this.data = response["indicadores"];
                let i = 0;
                let farolComoCorPrincipal = false;


                this.data.forEach(async element => {

                    // === Decide a cor principal e o farol visual ===
                    let corPrincipal, corFarolVisual;

                    if (element['farolCorPrincipal']) {
                        farolComoCorPrincipal = true;
                        const farolResp = await firstValueFrom(
                            this.indicadorService.GetFarol(this.postosUsuario, element['codigo'], login, this.receivedCcPosto)
                        );
                        corPrincipal = this.cores.find(c => c.status == farolResp["indicador_cor_farol"]);
                        corFarolVisual = undefined; // oculta o farol visual
                    } else {
                        corPrincipal = this.cores.find(c => c.status == element['cor']);
                        corFarolVisual = this.cores.find(c => c.status == element['corFarol']);
                    }

                    var newind = new boxInfo(
                        element['codigo'],
                        element['nome'],
                        element['linkRedirect'],
                        corPrincipal?.status === "Roxo" ? corPrincipal : this.cores.find(c => c.status == element['cor']),
                        element['valor']['valorFormatado'],
                        undefined,
                        element['icone'],
                        corFarolVisual,
                        false,
                        element['cabecalho'],
                        element['descricao']
                        //isUsarFarolComoCorPrincipal ? undefined : this.cores.find(x => x.status == element['corFarol']) // remove visual do farol
                    );
                    var oldind = this.listaInd.find(x => x.id == element['codigo']);
                    if (oldind != undefined) {
                        oldind.valor = newind.valor;
                        oldind.cor = newind.cor;
                        oldind.nome = newind.nome;
                        oldind.icone = newind.icone;
                        oldind.corfarol = newind.corfarol;
                        oldind.cabecalho = newind.cabecalho;
                    }
                });

                CodigosIndicador.forEach(element => {
                    var i = this.listaInd.find(x => x.id == element.trim())
                    if (i != undefined)
                        i.atualizando = false;
                });
            });
        }, (timeInterval * 1000));
        this.intervalIds.push(intervalId);
    }

    navigateWithState(Link: string | null, IdTela: string, valor: string, cabecalho: string | undefined) {
        if (this.receivedCcPosto != "") {
            this.listabreadcrumb[this.listabreadcrumb.length - 1].url = this.router.url.split('?')[0];
            var textInd = this.extractMatches(valor);
            if (cabecalho != null && cabecalho != undefined) {
                textInd = textInd + " (" + cabecalho + ")";
            }
            window.localStorage.setItem('breadcrumb', JSON.stringify(this.listabreadcrumb));
            this.router.navigate(['' + Link], {
                queryParams: { tipoTela: IdTela, CcPosto: this.receivedCcPosto, textInd: textInd, textPos: textInd }
            });
        }
        else {
            var textInd = this.extractMatches(valor);
            this.router.navigate(['' + Link], {
                queryParams: { tipoTela: IdTela, textInd: textInd }
            });
        }
    }

    navigateWithStateOrgao(Link: string | null, IdTela: string, valor: string, cabecalho: string) {
        var textInd = this.extractMatches(valor);
        if (cabecalho != null) {
            textInd = textInd + " (" + cabecalho + ")";
        }
        var CcPosto: string;
        var sala: any = localStorage.getItem('salaSituacao');
        sala = JSON.parse(sala);
        var posto = sala.postos;
        CcPosto = posto.toString();
        this.listabreadcrumb[this.listabreadcrumb.length - 1].url = this.router.url;
        var textPos = this.extractMatches(valor);
        this.router.navigate(['' + Link], {
            queryParams: { tipoTela: IdTela, CcPosto: CcPosto, textInd: textInd, textPos: textPos }
        });
    }

    extractMatches(valor: string): string {
        const regex = /\s\d+\/\d+/g;
        const matches = valor.match(regex);
        if (matches) {
            return " " + matches.join(' ').trim();
        }
        return "";
    }

}
